import { Component, Inject, OnInit } from "@angular/core";
import { AuthService } from "@core/auth.service";
import { encryptUsingAES256, isMobile, UtilityService } from "@core/utility.service";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatDialogRef } from "@angular/material/dialog";
import { filter } from "rxjs/operators";
import { Router } from "@angular/router";
import { MatIcon } from "@angular/material/icon";
@Component({
    selector: "app-chatbot-live-chat-pop",
    templateUrl: "./chatbot-live-chat-pop.component.html",
    styleUrls: ["./chatbot-live-chat-pop.component.scss"],
    standalone: true,
    imports: [MatIcon],
})
export class ChatbotLiveChatPopComponent implements OnInit {
  url: any;
  //chatBotUrl: any;
  liveUrl: string;
  user$ = this.authService.userDetails$;

  constructor(
    private sanitizer: DomSanitizer,
    private authService: AuthService,
    private matDialog: MatDialog,
    private dialogRef: MatDialogRef<ChatbotLiveChatPopComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router
  ) { }

  ngOnInit() {
    const encryptedToken = encryptUsingAES256(localStorage.getItem("fbToken"));
    this.liveUrl = `https://web.lottosocial.com/live-chat?token=${encryptedToken}`;
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.liveUrl);
  }
  goBack() {
    this.dialogRef.close();
  }
}
